export default {
  slots: {
    identity: {
      label: 'Act de identitate',
      hint: 'Carte de identitate, pașaport sau permis de ședere, față și verso. Aici se încarcă și actele partenerilor tăi.',
    },
    trade_registration: {
      label: 'Înregistrare comercială (Gewerbeanmeldung)',
      hint: 'Documentul de înregistrare comercială primit de la oficiul comercial.',
    },
    commercial_register_extract: {
      label: 'Extras din registrul comerțului (Handelsregisterauszug)',
      hint: 'Un extras actual din registrul comerțului, dacă afacerea ta este înregistrată acolo.',
    },
    bank_statement: {
      label: 'Extras de cont (Kontoauszug)',
      hint: 'Un extras recent al contului tău bancar de afaceri, care arată titularul contului și IBAN-ul.',
    },
    shareholder_list: {
      label: 'Lista acționarilor (Gesellschafterliste)',
      hint: 'Lista actuală a acționarilor.',
      hint_gbr: 'Contractul de asociere (Gesellschaftsvertrag) sau o listă cu toți partenerii.',
    },
    tax_number: {
      label: 'Cod fiscal sau cod de TVA (Steuernummer oder USt-IdNr.)',
      hint: 'O scrisoare de la administrația fiscală care arată codul tău fiscal, sau confirmarea codului de TVA.',
    },
  },
  tags: {
    required: 'Obligatoriu',
    optional: 'Opțional',
    missing: 'Lipsă',
  },
  kinds: {
    passport: 'Pașaport',
    driver_license: 'Permis de conducere',
    id_card: 'Carte de identitate',
    residence_permit: 'Permis de ședere',
  },
  holders: {
    owner: 'Proprietar',
    partner: 'Partener: {{name}}',
  },
  file: {
    with_back: 'Față și verso',
    uploaded_at: 'Încărcat {{date}}',
    expires_at: 'Valabil până la {{date}}',
  },
  errors: {
    load: 'Documentele nu au putut fi încărcate.',
  },
  empty: 'Niciun fișier încă',
  buttons: {
    add: 'Adaugă fișier',
    replace: 'Înlocuiește',
    remove: 'Elimină',
    retry: 'Încearcă din nou',
  },
  remove_confirm: {
    title: 'Elimini acest fișier?',
    description: 'Folosește asta pentru un fișier încărcat din greșeală.',
    ok: 'Elimină',
    cancel: 'Anulează',
  },
  toasts: {
    remove_success: 'Fișier eliminat',
    remove_error: 'Fișierul nu a putut fi eliminat. Te rugăm să încerci din nou.',
  },
};
